module.exports = __webpack_public_path__ + "static/Superspeed-0112bcb74564002739a8370f5775a790.png";